import React, { useState, useEffect} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../firebase';
import { useAuth

 } from './authContext';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import HomeIcon from '@mui/icons-material/Home';
import LuggageIcon from '@mui/icons-material/Luggage';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SettingsIcon from '@mui/icons-material/Settings';
import PaidIcon from '@mui/icons-material/Paid';
import LogoutIcon from '@mui/icons-material/Logout';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

// shopik.io is the production marketing site; use the stage equivalent off-prod
const MARKETING_HOME = process.env.REACT_APP_PROJECT_ID === 'shopik-production'
  ? 'https://shopik.io/'
  : 'https://shopik-next-stage.web.app/';

function getInitials(email) {
  if (!email) return '?';
  const name = email.split('@')[0];
  const parts = name.split(/[._-]/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
}

export default function DashboardLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const user = auth.currentUser;
  const { logout } = useAuth();

  // State to toggle the menu, default based on screen size
  const [menuOpen, setMenuOpen] = useState(window.innerWidth >= 768);

  useEffect(() => {
    // Function to update menu state based on window resize
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setMenuOpen(true);  // Expanded by default on desktop
      } else {
        setMenuOpen(false); // Collapsed by default on mobile
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    auth.signOut()
      .then(() => {
        navigate('/');
      })
      .catch((error) => {
        console.error("Error logging out: ", error);
      });
  };

  // Toggle the menu open/close on mobile
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const navItems = [
    { label: 'Product List', href: '/products-v2/' + user.uid, icon: <LuggageIcon fontSize="small" />, match: '/products-v2' },
    { label: 'Sales', href: '/sales/' + user.uid, icon: <PaidIcon fontSize="small" />, match: '/sales' },
    { label: 'Uploader', href: '/uploader', icon: <CloudUploadIcon fontSize="small" />, match: '/uploader' },
    { label: 'Settings', href: '/settings', icon: <SettingsIcon fontSize="small" />, match: '/settings' },
  ];

  return (
    <div className="dashboard-layout">
       <div className="top-nav">
    <button className="hamburger-menu" onClick={toggleMenu} aria-label={menuOpen ? "Close menu" : "Open menu"}>
      {menuOpen ? <CloseIcon /> : <MenuIcon />}
    </button>
    <div className="header-logo">
      <img src='./images/logo.png' height={22} alt="Hemlock"/>
    </div>
    <div className="user-info">
      <button className="logout-button" onClick={handleLogout}><LogoutIcon fontSize="small" /> Sign Out</button>
    </div>
  </div>
    <div className="dashboard-container">
      <aside className={`side-nav ${menuOpen ? 'open' : 'collapsed'}`}>
          <div className="side-nav-profile">
            <div className="side-nav-avatar">{getInitials(user?.email)}</div>
            <div className="side-nav-profile-text">
              <div className="side-nav-profile-name">{user?.displayName || 'My Account'}</div>
              <div className="side-nav-profile-email">{user ? user.email : 'Guest'}</div>
            </div>
          </div>
          <nav className="nav-menu">
            <div className="nav-section-label">Main</div>
            <ul>
              {/* <li>
                <a href={MARKETING_HOME} className={location.pathname === '/' ? 'active' : ''}>
                  <HomeIcon fontSize="small" /> Home
                </a>
              </li> */}
              {navItems.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className={location.pathname.startsWith(item.match) ? 'active' : ''}
                    onClick={(e) => {
                      // A plain browser navigation here does a full page reload,
                      // which kills any upload still running in the background
                      // (e.g. a single-item submit's for-loop mid-flight, see
                      // uploader.js handleSubmitGroup) without a chance to clean
                      // up, orphaning the product doc. Keep this in-SPA instead.
                      e.preventDefault();
                      navigate(item.href);
                    }}
                  >
                    {item.icon} {item.label}
                  </a>
                </li>
              ))}
            </ul>
            {/* <div className="nav-section-label">Account</div>
            <ul>
              <li>
                <a href="https://shopik.io/contact" target="_blank" rel="noreferrer" className="nav-link-between">
                  <span><HelpOutlineIcon fontSize="small" /> Help &amp; Support</span>
                  <ChevronRightIcon fontSize="small" />
                </a>
              </li>
            </ul> */}
          </nav>
        </aside>
        <div className={`side-nav-backdrop ${menuOpen ? 'visible' : ''}`} onClick={() => setMenuOpen(false)} />

        <div className="main-content">

          {children}
        </div>
      </div>
    </div>
  );
}